// extracted by mini-css-extract-plugin
export default {"searchContainer":"ModuleSearch_searchContainer__LHrEx"};